import classes from "./OneCategory.module.css";
import { useContext } from "react";
import { GenreContext } from "../../../store/GenreContext";
import { Link } from "react-scroll";

const Genre = ({ src, id, label, activeId }) => {
  const ctx = useContext(GenreContext);

  function fetchPlates() {
    ctx.fetchPlatesByCategory(id);
  }

  const offset =
    window.innerWidth < window.innerHeight
      ? (100 - 60) * (window.innerHeight / 100)
      : 100 * (window.innerHeight / 100);

  const imageSrc = `https://byfatsy.sophic-team.com/admin/${src}`;

  return (
    <Link
      offset={offset}
      smooth={true}
      className={`${classes.main} ${classes.box_shadow} ${
        activeId === id ? classes.active : ""
      }`}
      onClick={fetchPlates}
      duration={0}
      to="topSection"
    >
      <div className={classes.iconWrapper}>
        <img className={classes.icon} src={imageSrc} alt={label} />
      </div>
      <div className={classes.label}>{label}</div>
    </Link>
  );
};

export default Genre;
